import React, { Fragment, Suspense } from "react";
import "./styles.css";
import Header from "./Component/Header/Header";
import './App.css';

import {Route,BrowserRouter as Router, Switch } from 'react-router-dom';
import BottomTab from "./Component/BottomTabBar/BottomTab";
const Corona = React.lazy(() => import('./PageContainer/Corona'));

const NewsContainer = React.lazy(() => import('./PageContainer/NewsContainer'));

// const D3Charts = React.lazy(()=> import('./Component/charts/d3Charts'));
const HeatMap = React.lazy(()=> import('./Component/charts/HeatMap'));
//import * as axios from "axios";

const  App = () => {
  //console.log(corona);

 
  return (
    <Fragment>
      <Router>
      <Header />
      <Suspense fallback={<div style={{ display:'flex',flexDirection:'row',justifyContent:'center', alignItems:'center', width:'95vw', height:'100vh'}}>
        <div className="spinner-border text-success" style={{}}></div></div>} >
      <Switch>
        <Route exact path="/" component={Corona}></Route>
        <Route  path="/news" component={NewsContainer}></Route>
        <Route  path="/heatMap" component={HeatMap}></Route>
      </Switch>
      </Suspense>
      <BottomTab/>
      </Router>
      <div
        className="jumbotron jumbotron-fluid center footer"
      
      >
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-sm-4">
              <p style={{ fontWeight: "bold", fontSize: 20 }}>About</p>
              <p className="p">
                The one and only intention of this application to pass the
                information about Corona-19 virus affected people. This Virus is
                very much deadly. Please stay in home for your own safety.
              </p>
            </div>
            <div className="col-md-4 col-sm-4 zyz">
              <p style={{ fontWeight: "bold", fontSize: 20 }}>Prevention</p>
             
                <p className="p"> <i className="fas fa-hands-wash"></i> {"   "} Wash your hand often</p>
                <p className="p"> <i className="fas fa-head-side-mask"></i> {"   " } Use face mask</p>
                <p className="p">  <i className="fas fa-people-arrows"></i> {"   "}Avoid contact with sick people</p>
                <p className="p">  <i className="fas fa-head-side-cough-slash"> </i> {"   "}Always cover your cough and sneez</p>
             
            </div>
            <div className="col-md-4 col-sm-4">
              <p  style={{ fontWeight: "bold", fontSize: 20 }}>Contact</p>
              <p className="p">Adarsh Ranjan</p>
              <a style={{fontSize: '30px',borderRadius:'50%'}} href="https://www.linkedin.com/in/ranjanphy"> <i className="fab fa-linkedin"></i></a>
               {/* <p  className="p">www.linkedin.com/in/ranjanphy</p> */}
               {/* <div className="row">
                &nbsp; &nbsp;<span style={{fontSize: 30}}> <a target="_blank" href={"www.linkedin.com/in/ranjanphy"}><i className="fa fa-linkedin-square" aria-hidden="true"></i></a> </span>
               </div>  */}
            </div>
            {/* <div className="col-md-4 col-sm-4">
            <p style={{ fontWeight: "bold", fontSize: 20 }}>  Appreciate </p>
            <p><span style={{fontSize: 40, cursor:'pointer', textAlign:'center'}}>
              <i className="fa fa-thumbs-o-up" aria-hidden="true"></i></span></p>
            </div> */}
          </div>
          <div className="row">
          </div>
          <div><footer style={{textAlign:'center'}}>
          <img src={"https://www.webfreecounter.com/hit.php?id=grkoppn&nd=6&style=1"} border="0" alt="web counter"/>
            </footer></div>
          <div><footer style={{textAlign:'center',fontSize:'12px'}}>&copy; Copyright Reserved <a href="https://www.shareinfo.in"> https://www.shareinfo.in</a></footer></div>
        </div>
      </div>
    
    </Fragment>
  );
}

export default App;
